import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { illustrations } from 'components/Illustration';

const styles = theme => ({
  root: {
    maxWidth: '470px',
    marginRight: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  spacer: {
    height: '12px',
  }
});

const DomainDescription = ({ classes }) => {
  return (
    <Card className={classes.root}>
      <CardHeader title="What are website Domains?" />
      <CardContent className={classes.content}>
        <Typography>
          The address of your website can be shown in two different ways,
          a Sub Domain or your own Business Domain.
        </Typography>
        <div className={classes.spacer} />
        <Typography>
          {`A Sub Domain looks like this: www.<companyname>.couraggo.com.`}
        </Typography>
        <div className={classes.spacer} />
        <Typography>
          {`A Business Domain looks like this: www.<companyname>.com`}
        </Typography>
        <div className={classes.spacer} />
        <Typography>
          Couraggo initially hosts your website on a Sub Domain, but you'll
          look more professional with a Business Domain.
        </Typography>
        <div className={classes.spacer} />
        <img
          style={{ alignSelf: 'center', width: '200px', height: '200px' }}
          alt=""
          src={illustrations.get("domain_names_amber")}
        />
        <div className={classes.spacer} />
        <Typography>
          To get your own Business Domain, it must be registered with a
          domain registration company (e.g. GoDaddy, NameCheap, etc...).
        </Typography>
        <div className={classes.spacer} />
        <Typography>
          Luckily, we are working with NameCheap so you can get a Business Domain
          directly through Couraggo.
        </Typography>
        <div className={classes.spacer} />
        <Typography>
          Click on the GET BUSINESS DOMAIN button to get started.
        </Typography>
      </CardContent>

    </Card>
  );
}

export default withStyles(styles)(DomainDescription);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Domain/DomainDescription.jsx